export function PrivacyPolicy() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-20 md:p-24">
      <h1 className="text-h1-sm md:text-h1-md lg:text-h1-lg font-bold self-start mb-2">
        Privacy Policy
      </h1>
      <p role="doc-subtitle" className="self-start mb-5">
        Last updated 1 Mar 2024
      </p>
      <div className="flex flex-col gap-y-4">
        {/* This placeholder text should be replaced with a policy made by RZA */}
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi
          eleifend et tellus at commodo. Suspendisse fermentum elementum
          convallis. Fusce orci eros, dapibus euismod congue id, faucibus ut
          sem. Fusce rutrum nisl at quam euismod pulvinar. Vivamus ante felis,
          imperdiet non ullamcorper sit amet, vestibulum eu ex. Donec convallis
          viverra aliquam. Aliquam purus tellus, laoreet sed felis at, dapibus
          aliquet risus. Suspendisse eget ullamcorper nunc. Nullam viverra, est
          vel dictum tincidunt, nisi turpis tristique ante, sed sollicitudin
          urna elit sed est. In hac habitasse platea dictumst. In et dignissim
          felis, eu pellentesque orci. Phasellus efficitur fermentum nibh sed
          accumsan.
        </p>
        <p>
          In ullamcorper sodales massa, et posuere lacus tincidunt vel. Nullam a
          bibendum quam. Integer quis gravida nibh. Integer ex mi, mattis eu
          finibus in, consectetur a nibh. Suspendisse nec mattis sem, ut cursus
          sem. Duis pulvinar mauris tellus. Nullam hendrerit, orci sit amet
          posuere consectetur, turpis neque hendrerit nisi, ornare ornare urna
          metus vitae risus. Aenean tempus pretium malesuada. Pellentesque
          aliquet erat non augue molestie tincidunt. Etiam nec odio sit amet
          massa sagittis tempus ac vitae leo. Donec vulputate lobortis lorem,
          vitae dignissim est commodo non. Fusce a justo est. In nec elementum
          elit. Phasellus efficitur vitae arcu vitae finibus.
        </p>
        <p>
          Vivamus semper urna nisi, at finibus mauris fringilla ac. Aliquam id
          orci eu nibh vulputate convallis at sed enim. Nullam bibendum
          scelerisque sem eu tristique. Aenean ultricies eget est in vestibulum.
          Mauris ac aliquet velit, porttitor luctus risus. Fusce viverra
          interdum aliquam. Morbi non sollicitudin sapien, in porta ligula.
          Phasellus id imperdiet urna. Pellentesque ultrices iaculis sem, ut
          pellentesque enim ornare sed. Suspendisse sagittis quis sem ac
          facilisis.
        </p>
        <p>
          Etiam aliquet placerat commodo. Praesent consectetur, libero et
          scelerisque sagittis, dolor massa faucibus augue, ac varius mauris
          nunc et nulla. Ut eu vulputate nisi, nec consequat ex. Sed vulputate
          nisl eros, vel euismod orci ultricies non. Donec accumsan nulla ac
          massa tempus finibus. Donec fringilla rhoncus commodo. Phasellus id mi
          in turpis vestibulum egestas sit amet id sapien. Sed dui nisl,
          eleifend ut nunc at, commodo posuere dui. Sed sit amet dignissim odio.
          Nullam placerat eros faucibus mi porttitor, et fringilla erat mollis.
          Ut eget ornare sapien. Nullam iaculis lorem sed sem tristique, in
          dignissim nunc rhoncus. Donec venenatis placerat libero, id placerat
          lorem condimentum quis. Sed eu nibh tincidunt, tristique felis et,
          maximus nisi. Ut fringilla mi venenatis velit luctus vehicula. Nulla
          et nisi libero.
        </p>
        <p>
          Morbi convallis pharetra vulputate. Etiam non vestibulum nulla, nec
          blandit ipsum. Donec vel pellentesque arcu. Pellentesque vulputate
          risus ac lorem lobortis laoreet. Aliquam tristique tortor a tortor
          egestas, eu dictum mi fermentum. Maecenas imperdiet lacus eget
          convallis viverra. Mauris eget ligula in erat egestas laoreet vel ac
          ligula. Pellentesque eu facilisis nulla. Donec gravida vestibulum est
          vel condimentum. Ut lorem libero, iaculis non rutrum non, sollicitudin
          tincidunt tortor. Nam euismod tellus dui, sed posuere purus imperdiet
          quis. Integer placerat fermentum orci, vel hendrerit odio vehicula
          eget.
        </p>
      </div>
    </div>
  );
}
